<template>
  <div class="app-container">
    <!--加载进度-->
    <van-loading v-if="!isLoaded" class="loading" />
    <!--加载失败-->
    <div v-else-if="errorMessage" class="error-message">
      错误：{{ errorMessage }}
    </div>
    <!--加载成功-->
    <template v-else>
      <van-cell-group title="常用业务">
        <van-cell
          v-for="shortcut in shortcuts"
          :key="shortcut.id"
          :title="shortcut.name"
          :label="shortcut.description"
          size="large"
          :to="{ path: 'start', query: { businessTypeId: shortcut.businessTypeId,registrationItemId: shortcut.registrationItemId }}"
          :is-link="true"
        >
          <van-icon
            slot="icon"
            class="left-icon"
            :name="shortcut.iconClass|iconName"
            :color="shortcut.iconColor|iconColor"
            size="24px"
            class-prefix="iconfont"
          />
        </van-cell>
        <van-cell
          title="更多"
          size="large"
          :to="{ path: 'start' }"
          :is-link="true"
        >
          <van-icon
            slot="icon"
            class="left-icon"
            name="all"
            color="#B7B7B7"
            size="24px"
            class-prefix="iconfont"
          />
        </van-cell>
      </van-cell-group>
    </template>
  </div>
</template>

<script>
import { getApplicationShortcutList } from '@/api/application'

export default {
  filters: {
    iconName(name) {
      return name || 'all'
    },
    iconColor(color) {
      return color || '#666'
    }
  },
  data() {
    return {
      isLoaded: false,
      errorMessage: '',
      shortcuts: []
    }
  },
  created() {
    // 加载数据
    this.loadData()
  },
  methods: {
    // 加载数据
    loadData() {
      getApplicationShortcutList({
        isEnabled: true
      }).then(({ data }) => {
        this.shortcuts = data
        this.isLoaded = true
      }).catch(error => {
        this.errorMessage = error.message
      })
    }
  }
}
</script>

<style scoped lang="scss">
.app-container {
  min-height: 100vh;
  background-color: #ededed;
  .loading{
    padding-top: 15px;
    text-align: center;
  }
  .error-message{
    color: #ee0a24;
    padding-top: 15px;
    text-align: center;
  }
  .van-cell:not(:last-child)::after {
    left: 54px;
    border-bottom: 1px solid #d9d9d9;
  }
}
</style>
